// src/components/Shimmers/MarketplaceDetailsShimmer.tsx
import React from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";

export default function MarketplaceDetailsShimmer() {
  return (
    <Container fluid className="py-5">
      {/* Header shimmer */}
      <Card className="mb-4 shadow-sm border-0">
        <div className="bg-light p-4 d-flex align-items-center justify-content-between flex-wrap rounded">
          <div className="d-flex align-items-center col-8 p-0">
            <div className="placeholder rounded" style={{ width: 70, height: 70 }} />
            <div className="ms-3 col-6">
              <div className="placeholder-glow">
                <span className="placeholder col-6 mb-2 d-block" />
              </div>
              <div className="placeholder-glow">
                <span className="placeholder col-4 d-block" />
              </div>
            </div>
          </div>
          <div className="placeholder rounded-pill" style={{ width: 100, height: 32 }} />
        </div>
      </Card>

      <Row className="gx-5">
        {/* Left column shimmer */}
        <Col lg={8}>
          {/* Accounts section shimmer */}
          <Card className="mb-4 shadow-sm">
            <CardBody className="p-4">
              <div className="placeholder-glow mb-3">
                <span className="placeholder col-4" />
              </div>
              {Array.from({ length: 3 }).map((_, i) => (
                <div key={i} className="d-flex justify-content-between align-items-center py-3">
                  <span className="placeholder col-6" />
                  <span className="placeholder col-2" />
                </div>
              ))}
            </CardBody>
          </Card>

          {/* Overview shimmer */}
          {["Overview", "Key Features", "Shared Data", "Permissions"].map((title, i) => (
            <Card className="mb-4 shadow-sm" key={i}>
              <div className="border-0 d-flex align-items-center p-3">
                <div className="placeholder rounded-circle me-2" style={{ width: 24, height: 24 }} />
                <div className="placeholder-glow">
                  <span className="placeholder col-3" />
                </div>
              </div>
              <CardBody>
                {Array.from({ length: 4 }).map((_, j) => (
                  <div className="placeholder-glow mb-2" key={j}>
                    <span className="placeholder w-100" style={{ height: 16, display: "block" }} />
                  </div>
                ))}
              </CardBody>
            </Card>
          ))}
        </Col>

        {/* Right column shimmer */}
        <Col lg={4}>
          <Card className="mb-4 shadow-sm">
            <div className="border-0 p-3">
              <div className="placeholder-glow">
                <span className="placeholder col-4" />
              </div>
            </div>
            <CardBody>
              <div className="placeholder-glow mb-2">
                <span className="placeholder col-6" />
              </div>
              <div className="placeholder-glow">
                <span className="placeholder col-5" />
              </div>
            </CardBody>
            <CardBody className="text-center border-top">
              <div className="placeholder-glow">
                <span className="placeholder col-6 d-block mx-auto" />
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
